import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const TermosDeUso = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <Link to="/" className="inline-flex items-center text-teal-600 hover:text-teal-700 mb-6">
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar para o início
        </Link>
        
        <Card className="shadow-lg">
          <CardHeader className="border-b bg-gradient-to-r from-slate-800 to-slate-700 text-white rounded-t-lg">
            <CardTitle className="flex items-center gap-3 text-2xl">
              <FileText className="h-6 w-6" />
              Termos de Uso
            </CardTitle>
            <p className="text-slate-300 mt-2">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
          </CardHeader>
          <CardContent className="prose prose-slate max-w-none p-8">
            <h2 className="text-xl font-bold text-slate-800 mt-0">1. Aceitação dos Termos</h2>
            <p className="text-slate-600">
              Ao acessar e utilizar a plataforma CERP Brasil NR1 ("Plataforma"), você ("Usuário") concorda 
              em cumprir e estar sujeito aos seguintes Termos de Uso. Se você não concordar com qualquer 
              parte destes termos, não deverá utilizar nossos serviços.
            </p>

            <h2 className="text-xl font-bold text-slate-800">2. Descrição dos Serviços</h2>
            <p className="text-slate-600">
              A Plataforma CERP Brasil NR1 oferece serviços de gestão de Segurança e Saúde no Trabalho (SST), 
              incluindo, mas não se limitando a:
            </p>
            <ul className="text-slate-600">
              <li>Gerenciamento de Riscos Ocupacionais (GRO)</li>
              <li>Programa de Gerenciamento de Riscos (PGR)</li>
              <li>Avaliação de Riscos Psicossociais</li>
              <li>Avaliação Ergonômica Preliminar (AEP)</li>
              <li>Gestão de Funcionários e Treinamentos</li>
              <li>Geração de Relatórios e Documentos</li>
            </ul>

            <h2 className="text-xl font-bold text-slate-800">3. Cadastro e Conta do Usuário</h2>
            <p className="text-slate-600">
              Para utilizar a Plataforma, o Usuário deve criar uma conta fornecendo informações verdadeiras, 
              completas e atualizadas. O Usuário é responsável por manter a confidencialidade de sua senha 
              e por todas as atividades realizadas em sua conta.
            </p>

            <h2 className="text-xl font-bold text-slate-800">4. Uso Aceitável</h2>
            <p className="text-slate-600">O Usuário concorda em não:</p>
            <ul className="text-slate-600">
              <li>Violar leis ou regulamentos aplicáveis</li>
              <li>Transmitir conteúdo ilegal, difamatório ou prejudicial</li>
              <li>Interferir na operação da Plataforma</li>
              <li>Tentar acessar áreas não autorizadas do sistema</li>
              <li>Compartilhar credenciais de acesso com terceiros não autorizados</li>
            </ul>

            <h2 className="text-xl font-bold text-slate-800">5. Propriedade Intelectual</h2>
            <p className="text-slate-600">
              Todo o conteúdo da Plataforma, incluindo textos, gráficos, logotipos, ícones, imagens, 
              clipes de áudio, downloads digitais e compilações de dados, é propriedade da CERP Brasil 
              ou de seus fornecedores de conteúdo e está protegido por leis de direitos autorais.
            </p>

            <h2 className="text-xl font-bold text-slate-800">6. Dados e Privacidade</h2>
            <p className="text-slate-600">
              O uso de dados pessoais é regido por nossa Política de Privacidade. Ao utilizar a Plataforma, 
              o Usuário consente com a coleta, uso e compartilhamento de informações conforme descrito 
              nessa política.
            </p>

            <h2 className="text-xl font-bold text-slate-800">7. Limitação de Responsabilidade</h2>
            <p className="text-slate-600">
              A Plataforma é fornecida "como está" e "conforme disponibilidade". Não garantimos que os 
              serviços serão ininterruptos, livres de erros ou seguros. Em nenhuma circunstância seremos 
              responsáveis por danos indiretos, incidentais, especiais ou consequenciais.
            </p>

            <h2 className="text-xl font-bold text-slate-800">8. Conformidade Legal</h2>
            <p className="text-slate-600">
              A Plataforma foi desenvolvida para auxiliar no cumprimento das Normas Regulamentadoras (NRs) 
              do Ministério do Trabalho e Emprego. No entanto, a responsabilidade final pelo cumprimento 
              das obrigações legais permanece com o Usuário e sua empresa.
            </p>

            <h2 className="text-xl font-bold text-slate-800">9. Modificações dos Termos</h2>
            <p className="text-slate-600">
              Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. As alterações 
              entrarão em vigor imediatamente após sua publicação na Plataforma. O uso continuado dos 
              serviços após tais alterações constitui aceitação dos novos termos.
            </p>

            <h2 className="text-xl font-bold text-slate-800">10. Rescisão</h2>
            <p className="text-slate-600">
              Podemos encerrar ou suspender o acesso do Usuário à Plataforma imediatamente, sem aviso 
              prévio ou responsabilidade, por qualquer motivo, incluindo, sem limitação, violação destes 
              Termos de Uso.
            </p>

            <h2 className="text-xl font-bold text-slate-800">11. Lei Aplicável</h2>
            <p className="text-slate-600">
              Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Qualquer 
              disputa será resolvida nos tribunais competentes do Brasil.
            </p>

            <h2 className="text-xl font-bold text-slate-800">12. Contato</h2>
            <p className="text-slate-600">
              Para dúvidas sobre estes Termos de Uso, entre em contato conosco pelo email: 
              <a href="mailto:contato@cerpbrasil.com.br" className="text-teal-600 hover:underline ml-1">
                contato@cerpbrasil.com.br
              </a>
            </p>

            <div className="mt-8 p-4 bg-slate-100 rounded-lg border">
              <p className="text-sm text-slate-600 mb-2">
                <strong>Razão Social:</strong> Karina Di Paula Santana Soares LTDA<br />
                <strong>Nome Fantasia:</strong> Ogunhê Desenvolvimento de Sistemas<br />
                <strong>CNPJ:</strong> 66.298.458/0001-87<br />
                <strong>Inscrição Municipal:</strong> 2798824<br />
                <strong>Endereço:</strong> Rua Paes Leme, 215, Conj 1713 - Pinheiros, São Paulo - SP, CEP 05424-150
              </p>
              <p className="text-sm text-slate-500 mb-0">
                <strong>Versão:</strong> 1.0 | <strong>Data:</strong> {new Date().toLocaleDateString('pt-BR')}
              </p>
            </div>
          </CardContent>
        </Card>

        <div className="mt-6 text-center">
          <Link to="/politica-de-privacidade">
            <Button variant="outline" className="mr-4">
              Ver Política de Privacidade
            </Button>
          </Link>
          <Link to="/login">
            <Button className="bg-teal-600 hover:bg-teal-700">
              Fazer Login
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermosDeUso;
